module.exports = __webpack_public_path__ + "static/media/not-the-page.e808e50f.gif";